module.exports = __webpack_public_path__ + "6bc41e6994139e50f6549a193839acf8.otf";